"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _withScopeId = (n) => ((0, vue_2.pushScopeId)("data-v-1576936e"), n = n(), (0, vue_2.popScopeId)(), n);
const _hoisted_1 = { class: "main-settings-container" };
const _hoisted_2 = { class: "settings-card-container" };
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "settings-title-wrapper" }, [
    /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "page-title-text" }, "連携設定")
], -1 /* HOISTED */));
const _hoisted_4 = { class: "settings-item" };
const _hoisted_5 = { class: "settings-item-name-wrapper flex-center" };
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "settings-item-name" }, "移動前の拠点からスタッフ情報を自動で削除", -1 /* HOISTED */));
const _hoisted_7 = {
    class: "tooltip-container",
    tabindex: "0"
};
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "tooltip-wrapper" }, [
    /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "tooltip-text" }, "インポート時に拠点が変更されていた場合、拠点の割り当てを自動的に更新します。")
], -1 /* HOISTED */));
const _hoisted_9 = { class: "settings-input oplus-form-switch" };
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* HOISTED */));
const _hoisted_11 = { class: "settings-card-container" };
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "settings-title-wrapper" }, [
    /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "page-title-text" }, "連携先"),
    /*#__PURE__*/ (0, vue_2.createElementVNode)("i", {
        class: "oem-alert-tooltip zmdi zmdi-alert-circle zmdi-hc-lg tooltip tooltip-right text-error",
        "data-tooltip": "現在の設定を上書きして、設定を変更します。"
    })
], -1 /* HOISTED */));
const _hoisted_13 = { class: "settings-item" };
const _hoisted_14 = { class: "settings-item-name-wrapper flex-center" };
const _hoisted_15 = { class: "settings-item-name" };
const _hoisted_16 = {
    class: "tooltip-container",
    tabindex: "0"
};
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "tooltip-wrapper" }, [
    /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "tooltip-text" }, "シフトの情報が「King of Time」のスケジュールに追加される。")
], -1 /* HOISTED */));
const _hoisted_18 = { class: "settings-input oplus-form-switch" };
const _hoisted_19 = ["checked", "value"];
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* HOISTED */));
const _hoisted_21 = { class: "settings-item-name-wrapper flex-center" };
const _hoisted_22 = { class: "settings-item-name" };
const _hoisted_23 = {
    key: 0,
    class: "hide-sm"
};
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("br", null, null, -1 /* HOISTED */));
const _hoisted_25 = {
    class: "tooltip-container",
    tabindex: "0"
};
const _hoisted_26 = { class: "tooltip-wrapper" };
const _hoisted_27 = { class: "tooltip-text" };
const _hoisted_28 = { class: "settings-input oplus-form-switch" };
const _hoisted_29 = ["checked", "value", "onChange"];
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* HOISTED */));
const _hoisted_31 = { class: "settings-item" };
const _hoisted_32 = { class: "settings-item-name-wrapper flex-center" };
const _hoisted_33 = { class: "settings-item-name" };
const _hoisted_34 = {
    class: "tooltip-container",
    tabindex: "0"
};
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "tooltip-wrapper" }, [
    /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "tooltip-text" }, "MoneyForwardと連携をする。")
], -1 /* HOISTED */));
const _hoisted_36 = {
    key: 0,
    class: "pro-label ml-2"
};
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* HOISTED */));
const _hoisted_38 = {
    key: 0,
    class: "flex-end mf-sync-only"
};
const _hoisted_39 = { class: "oplus-form-checkbox" };
const _hoisted_40 = { class: "settings-item" };
const _hoisted_41 = { class: "settings-item-name-wrapper flex-center" };
const _hoisted_42 = { class: "settings-item-name" };
const _hoisted_43 = {
    class: "tooltip-container",
    tabindex: "0"
};
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "tooltip-wrapper tooltip-wrapper-top" }, [
    /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "tooltip-text" }, "CC-Bizmateと連携する")
], -1 /* HOISTED */));
const _hoisted_45 = {
    key: 0,
    class: "pro-label ml-2"
};
const _hoisted_46 = { class: "settings-input d-flex flex-column cc-biz-input" };
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* HOISTED */));
const _hoisted_48 = {
    key: 0,
    class: "settings-input oplus-form"
};
const _hoisted_49 = { class: "settings-item" };
const _hoisted_50 = { class: "settings-item-name-wrapper flex-center" };
const _hoisted_51 = { class: "settings-item-name" };
const _hoisted_52 = {
    class: "tooltip-container",
    tabindex: "0"
};
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "tooltip-wrapper tooltip-wrapper-top" }, [
    /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "tooltip-text" }, "SmartHRと連携をする。")
], -1 /* HOISTED */));
const _hoisted_54 = {
    key: 0,
    class: "pro-label ml-2"
};
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* HOISTED */));
const _hoisted_56 = { class: "settings-item" };
const _hoisted_57 = { class: "settings-item-name-wrapper flex-center" };
const _hoisted_58 = { class: "settings-item-name" };
const _hoisted_59 = {
    class: "tooltip-container",
    tabindex: "0"
};
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "tooltip-wrapper tooltip-wrapper-top" }, [
    /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "tooltip-text" }, "ミナジンと連携をする。")
], -1 /* HOISTED */));
const _hoisted_61 = {
    key: 0,
    class: "pro-label ml-2"
};
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* HOISTED */));
const _hoisted_63 = { class: "settings-item" };
const _hoisted_64 = { class: "settings-item-name-wrapper flex-center" };
const _hoisted_65 = { class: "settings-item-name" };
const _hoisted_66 = {
    class: "tooltip-container",
    tabindex: "0"
};
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "tooltip-wrapper tooltip-wrapper-top" }, [
    /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "tooltip-text" }, "Xronosと連携をする。")
], -1 /* HOISTED */));
const _hoisted_68 = {
    key: 0,
    class: "pro-label ml-2"
};
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* HOISTED */));
const _hoisted_70 = {
    key: 1,
    class: "settings-item"
};
const _hoisted_71 = { class: "settings-item-name-wrapper flex-center" };
const _hoisted_72 = { class: "settings-item-name" };
const _hoisted_73 = {
    class: "tooltip-container",
    tabindex: "0"
};
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "tooltip-wrapper tooltip-wrapper-top" }, [
    /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "tooltip-text" }, "PathosLogosと連携をする。")
], -1 /* HOISTED */));
const _hoisted_75 = {
    key: 0,
    class: "pro-label ml-2"
};
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* HOISTED */));
const _hoisted_77 = { class: "settings-item" };
const _hoisted_78 = { class: "settings-item-name-wrapper flex-center" };
const _hoisted_79 = { class: "settings-item-name" };
const _hoisted_80 = {
    class: "tooltip-container",
    tabindex: "0"
};
const _hoisted_81 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "tooltip-wrapper tooltip-wrapper-top" }, [
    /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "tooltip-text" }, "勤次郎への出力を有効にする")
], -1 /* HOISTED */));
const _hoisted_82 = {
    key: 0,
    class: "pro-label ml-2"
};
const _hoisted_83 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* HOISTED */));
const _hoisted_84 = { class: "settings-submit-button-wrapper" };
const vue_3 = require("vue");
const InfoIcon_vue_1 = __importDefault(require("../icons/InfoIcon.vue"));
const group_1 = require("../../requests/group");
const settings_1 = require("../../js/settings");
const KOTIcon_vue_1 = __importDefault(require("../icons/KOTIcon.vue"));
const KOTSmallIcon_vue_1 = __importDefault(require("../icons/KOTSmallIcon.vue"));
const NecIcon_vue_1 = __importDefault(require("../icons/NecIcon.vue"));
const NecSmallIcon_vue_1 = __importDefault(require("../icons/NecSmallIcon.vue"));
const TotIcon_vue_1 = __importDefault(require("../icons/TotIcon.vue"));
const TotSmallIcon_vue_1 = __importDefault(require("../icons/TotSmallIcon.vue"));
const SecomSmallIcon_vue_1 = __importDefault(require("../icons/SecomSmallIcon.vue"));
const OmakaseSmallIcon_vue_1 = __importDefault(require("../icons/OmakaseSmallIcon.vue"));
const FreePlusIcon_vue_1 = __importDefault(require("../icons/FreePlusIcon.vue"));
const FreePlusSmallIcon_vue_1 = __importDefault(require("../icons/FreePlusSmallIcon.vue"));
const OfficeStationSmallIcon_vue_1 = __importDefault(require("../icons/OfficeStationSmallIcon.vue"));
const OfficeStationIcon_vue_1 = __importDefault(require("../icons/OfficeStationIcon.vue"));
const MoneyForwardIcon_vue_1 = __importDefault(require("../icons/MoneyForwardIcon.vue"));
const MoneyForwardSmallIcon_vue_1 = __importDefault(require("../icons/MoneyForwardSmallIcon.vue"));
const CCBizIcon_vue_1 = __importDefault(require("../icons/CCBizIcon.vue"));
const CCBizSmallIcon_vue_1 = __importDefault(require("../icons/CCBizSmallIcon.vue"));
const SmartHRIcon_vue_1 = __importDefault(require("../icons/SmartHRIcon.vue"));
const SmartHRSmallIcon_vue_1 = __importDefault(require("../icons/SmartHRSmallIcon.vue"));
const MinajinIcon_vue_1 = __importDefault(require("../icons/MinajinIcon.vue"));
const MinajinSmallIcon_vue_1 = __importDefault(require("../icons/MinajinSmallIcon.vue"));
const PathosLogosIcon_vue_1 = __importDefault(require("../icons/PathosLogosIcon.vue"));
const PathosLogosSmallIcon_vue_1 = __importDefault(require("../icons/PathosLogosSmallIcon.vue"));
const XronosIcon_vue_1 = __importDefault(require("../icons/XronosIcon.vue"));
const XronosSmallIcon_vue_1 = __importDefault(require("../icons/XronosSmallIcon.vue"));
const OmakaseIcon_vue_1 = __importDefault(require("../icons/OmakaseIcon.vue"));
const KinjiroSmallIcon_vue_1 = __importDefault(require("../icons/KinjiroSmallIcon.vue"));
const KinjiroIcon_vue_1 = __importDefault(require("../icons/KinjiroIcon.vue"));
exports.default = (0, vue_1.defineComponent)({
    __name: 'SettingsOEMContent',
    props: {
        integrationSettings: {
            type: Object,
            required: false,
        },
        groupData: {
            type: Object,
            required: true
        },
        meStore: {
            type: Object,
            required: true,
        },
        permissions: {
            type: Object,
            required: true,
        },
    },
    setup(__props) {
        const props = __props;
        const defaultIntegrationSettings = () => ({
            enableMoneyForward: false,
            enableMinajin: false,
            enableSmartHR: false,
            enablePathosLogos: false,
            enableXronos: false,
            enableKinjiro: false,
            apiRemoveExisting: false,
            moneyForwardSyncOnly: false,
        });
        const { hasProPerm, hasTrialPerm, hasCCBizPerm, hasPathosLogosPerm } = props.permissions;
        const localSettingsData = (0, vue_3.ref)({ ...props.integrationSettings || defaultIntegrationSettings() });
        const selectedOem = (0, vue_3.ref)(props.groupData.getGroupSettings().getSelectedOem());
        const kotEnabled = (0, vue_3.ref)(props.permissions.hasKotPerm);
        const isLoading = (0, vue_3.ref)(false);
        const description = (keyText) => `シフトの情報が「${keyText}」のスケジュールに追加される。`;
        const oemSettingsData = {
            nec: {
                title: '勤革時',
                title2: '',
                icon1: NecIcon_vue_1.default,
                icon2: NecSmallIcon_vue_1.default,
                description: description('勤革時'),
                value: 1,
            },
            tot: {
                title: 'Touch On Time',
                title2: '',
                icon1: TotIcon_vue_1.default,
                icon2: TotSmallIcon_vue_1.default,
                description: description('Touch On Time'),
                value: 2,
            },
            secom: {
                title: 'セコムあんしん',
                title2: '勤怠管理サービス',
                icon1: SecomSmallIcon_vue_1.default,
                icon2: '',
                description: description('セコムあんしん勤怠管理サービス'),
                value: 3,
            },
            nttEast: {
                title: 'おまかせは',
                title2: 'たラクサポート',
                icon1: OmakaseIcon_vue_1.default,
                icon2: OmakaseSmallIcon_vue_1.default,
                description: description('おまかせはたラクサポート'),
                value: 4,
            },
            freee: {
                title: 'freee',
                title2: '勤怠管理 Plus',
                icon1: FreePlusIcon_vue_1.default,
                icon2: FreePlusSmallIcon_vue_1.default,
                description: description('freee 勤怠管理 Plus'),
                value: 5,
            },
            fandm: {
                title: 'オフィス',
                title2: 'ステーション勤怠',
                icon1: OfficeStationIcon_vue_1.default,
                icon2: OfficeStationSmallIcon_vue_1.default,
                description: description('オフィスステーション勤怠'),
                value: 6,
            }
        };
        const kotSelected = (0, vue_3.computed)(() => {
            return kotEnabled.value && selectedOem.value === 0;
        });
        function handleKotChange(e) {
            const target = e.target;
            const isChecked = target.checked;
            kotEnabled.value = isChecked;
            if (isChecked) {
                selectedOem.value = 0;
                return;
            }
        }
        function handleOemChange(event, key) {
            const data = oemSettingsData[key];
            const target = event.target;
            const isChecked = target.checked;
            selectedOem.value = 0;
            kotEnabled.value = false;
            if (isChecked) {
                selectedOem.value = data.value;
                kotEnabled.value = true;
            }
        }
        async function handleOemSubmit() {
            if (isLoading.value) {
                return;
            }
            isLoading.value = true;
            try {
                const group = props.groupData;
                const payload = {
                    id: group.getId(),
                    name: group.getGroupName(),
                    address: group.getGroupAddress(),
                    selectedOem: selectedOem.value,
                    kotEnabled: kotEnabled.value,
                    ccBizCompanyId: showCcBizInput.value ? localSettingsData.value.ccBizCompanyId : '',
                    integrationSettings: localSettingsData.value,
                };
                await (0, group_1.updateGroup)(props.meStore.getActiveUserId(), payload);
                (0, settings_1.importAlertModal)().alertSuccess("連携先を変更しました。");
            }
            catch (err) {
                (0, settings_1.importAlertModal)().alert(err);
            }
            finally {
                isLoading.value = false;
            }
        }
        const ccBizInput = (0, vue_3.computed)({
            get: () => {
                if (localSettingsData.value.ccBizCompanyId) {
                    return localSettingsData.value.ccBizCompanyId;
                }
            },
            set: (value) => {
                localSettingsData.value.ccBizCompanyId = value;
            },
        });
        const showCcBizInput = (0, vue_3.ref)(false);
        const ccbizCheckbox = (0, vue_3.computed)({
            get: () => {
                if (ccBizInput.value) {
                    showCcBizInput.value = true;
                    return true;
                }
                else {
                    showCcBizInput.value = false;
                    return false;
                }
            },
            set: (value) => {
                showCcBizInput.value = value;
            }
        });
        const loadingClass = (0, vue_3.computed)(() => {
            return {
                "loading": isLoading.value,
            };
        });
        const disabledCCBiz = (0, vue_3.computed)(() => {
            return !hasCCBizPerm ? 'disabled-btn' : '';
        });
        const disabledBtn = (0, vue_3.computed)(() => {
            return !hasTrialPerm && !hasProPerm ? 'disabled-btn' : '';
        });
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                (0, vue_2.createCommentVNode)(" Integration Settings "),
                (0, vue_2.createElementVNode)("div", _hoisted_2, [
                    _hoisted_3,
                    (0, vue_2.createCommentVNode)(" apiRemoveExisting "),
                    (0, vue_2.createElementVNode)("div", _hoisted_4, [
                        (0, vue_2.createElementVNode)("div", _hoisted_5, [
                            _hoisted_6,
                            (0, vue_2.createElementVNode)("div", _hoisted_7, [
                                (0, vue_2.createVNode)(InfoIcon_vue_1.default, { class: "show-sm" }),
                                _hoisted_8
                            ])
                        ]),
                        (0, vue_2.createElementVNode)("label", _hoisted_9, [
                            (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((localSettingsData.value.apiRemoveExisting) = $event)),
                                type: "checkbox"
                            }, null, 512 /* NEED_PATCH */), [
                                [vue_2.vModelCheckbox, localSettingsData.value.apiRemoveExisting]
                            ]),
                            _hoisted_10
                        ])
                    ])
                ]),
                (0, vue_2.createElementVNode)("div", _hoisted_11, [
                    _hoisted_12,
                    (0, vue_2.createElementVNode)("div", _hoisted_13, [
                        (0, vue_2.createElementVNode)("div", _hoisted_14, [
                            (0, vue_2.createElementVNode)("span", _hoisted_15, [
                                (0, vue_2.createVNode)(KOTIcon_vue_1.default, { class: "hide-sm" }),
                                (0, vue_2.createVNode)(KOTSmallIcon_vue_1.default, { class: "show-sm" })
                            ]),
                            (0, vue_2.createElementVNode)("div", _hoisted_16, [
                                (0, vue_2.createVNode)(InfoIcon_vue_1.default, { class: "show-sm" }),
                                _hoisted_17
                            ])
                        ]),
                        (0, vue_2.createElementVNode)("label", _hoisted_18, [
                            (0, vue_2.createElementVNode)("input", {
                                checked: kotSelected.value,
                                value: kotEnabled.value,
                                type: "checkbox",
                                onChange: handleKotChange
                            }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_19),
                            _hoisted_20
                        ])
                    ]),
                    ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(oemSettingsData, (oemSetting, key) => {
                        return (0, vue_2.createElementVNode)("div", {
                            class: "settings-item oem-settings-item",
                            key: key
                        }, [
                            (0, vue_2.createElementVNode)("div", _hoisted_21, [
                                (0, vue_2.createElementVNode)("span", _hoisted_22, [
                                    (!oemSetting.icon1)
                                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_23, [
                                            (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)(oemSetting.title), 1 /* TEXT */),
                                            _hoisted_24,
                                            (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)(oemSetting.title2), 1 /* TEXT */)
                                        ]))
                                        : (0, vue_2.createCommentVNode)("v-if", true),
                                    (oemSetting.icon1)
                                        ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)((0, vue_2.resolveDynamicComponent)(oemSetting.icon1), {
                                            key: 1,
                                            class: (0, vue_2.normalizeClass)({ 'hide-sm': oemSetting?.icon2 })
                                        }, null, 8 /* PROPS */, ["class"]))
                                        : (0, vue_2.createCommentVNode)("v-if", true),
                                    (oemSetting.icon2)
                                        ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)((0, vue_2.resolveDynamicComponent)(oemSetting.icon2), {
                                            key: 2,
                                            class: "show-sm"
                                        }))
                                        : (0, vue_2.createCommentVNode)("v-if", true)
                                ]),
                                (0, vue_2.createElementVNode)("div", _hoisted_25, [
                                    (0, vue_2.createVNode)(InfoIcon_vue_1.default, { class: "show-sm" }),
                                    (0, vue_2.createElementVNode)("div", _hoisted_26, [
                                        (0, vue_2.createElementVNode)("span", _hoisted_27, (0, vue_2.toDisplayString)(oemSetting.description), 1 /* TEXT */)
                                    ])
                                ])
                            ]),
                            (0, vue_2.createElementVNode)("label", _hoisted_28, [
                                (0, vue_2.createElementVNode)("input", {
                                    checked: oemSetting.value === selectedOem.value,
                                    value: oemSetting.value,
                                    type: "checkbox",
                                    onChange: ($event) => (handleOemChange($event, key))
                                }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_29),
                                _hoisted_30
                            ])
                        ]);
                    }), 64 /* STABLE_FRAGMENT */)),
                    (0, vue_2.createCommentVNode)(" MF "),
                    (0, vue_2.createElementVNode)("div", _hoisted_31, [
                        (0, vue_2.createElementVNode)("div", _hoisted_32, [
                            (0, vue_2.createElementVNode)("span", _hoisted_33, [
                                (0, vue_2.createVNode)(MoneyForwardIcon_vue_1.default, { class: "hide-sm" }),
                                (0, vue_2.createVNode)(MoneyForwardSmallIcon_vue_1.default, { class: "show-sm" })
                            ]),
                            (0, vue_2.createElementVNode)("div", _hoisted_34, [
                                (0, vue_2.createVNode)(InfoIcon_vue_1.default, { class: "show-sm" }),
                                _hoisted_35
                            ])
                        ]),
                        (!(0, vue_2.unref)(hasProPerm))
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_36))
                            : (0, vue_2.createCommentVNode)("v-if", true),
                        (0, vue_2.createElementVNode)("label", {
                            class: (0, vue_2.normalizeClass)(["settings-input oplus-form-switch", disabledBtn.value])
                        }, [
                            (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((localSettingsData.value.enableMoneyForward) = $event)),
                                type: "checkbox"
                            }, null, 512 /* NEED_PATCH */), [
                                [vue_2.vModelCheckbox, localSettingsData.value.enableMoneyForward]
                            ]),
                            _hoisted_37
                        ], 2 /* CLASS */)
                    ]),
                    (localSettingsData.value.enableMoneyForward)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_38, [
                            (0, vue_2.createElementVNode)("label", _hoisted_39, [
                                (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((localSettingsData.value.moneyForwardSyncOnly) = $event)),
                                    type: "checkbox"
                                }, null, 512 /* NEED_PATCH */), [
                                    [vue_2.vModelCheckbox, localSettingsData.value.moneyForwardSyncOnly]
                                ]),
                                (0, vue_2.createTextVNode)(" oplusに登録済みのスタッフのみを同期する（新しいスタッフは自動作成しません。ユーザーIDの一致が必要です）。 ")
                            ])
                        ]))
                        : (0, vue_2.createCommentVNode)("v-if", true),
                    (0, vue_2.createCommentVNode)(" CCBIZ "),
                    (0, vue_2.createElementVNode)("div", _hoisted_40, [
                        (0, vue_2.createElementVNode)("div", _hoisted_41, [
                            (0, vue_2.createElementVNode)("span", _hoisted_42, [
                                (0, vue_2.createVNode)(CCBizIcon_vue_1.default, { class: "hide-sm" }),
                                (0, vue_2.createVNode)(CCBizSmallIcon_vue_1.default, { class: "show-sm" })
                            ]),
                            (0, vue_2.createElementVNode)("div", _hoisted_43, [
                                (0, vue_2.createVNode)(InfoIcon_vue_1.default, { class: "show-sm" }),
                                _hoisted_44
                            ])
                        ]),
                        (!(0, vue_2.unref)(hasProPerm))
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_45))
                            : (0, vue_2.createCommentVNode)("v-if", true),
                        (0, vue_2.createElementVNode)("div", _hoisted_46, [
                            (0, vue_2.createElementVNode)("label", {
                                class: (0, vue_2.normalizeClass)(["oplus-form-switch", disabledCCBiz.value])
                            }, [
                                (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((ccbizCheckbox).value = $event)),
                                    type: "checkbox"
                                }, null, 512 /* NEED_PATCH */), [
                                    [vue_2.vModelCheckbox, ccbizCheckbox.value]
                                ]),
                                _hoisted_47
                            ], 2 /* CLASS */),
                            (showCcBizInput.value)
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("label", _hoisted_48, [
                                    (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((ccBizInput).value = $event)),
                                        class: "form-input",
                                        type: "text",
                                        placeholder: "会社ID"
                                    }, null, 512 /* NEED_PATCH */), [
                                        [vue_2.vModelText, ccBizInput.value]
                                    ])
                                ]))
                                : (0, vue_2.createCommentVNode)("v-if", true)
                        ])
                    ]),
                    (0, vue_2.createCommentVNode)(" SmartHR "),
                    (0, vue_2.createElementVNode)("div", _hoisted_49, [
                        (0, vue_2.createElementVNode)("div", _hoisted_50, [
                            (0, vue_2.createElementVNode)("span", _hoisted_51, [
                                (0, vue_2.createVNode)(SmartHRIcon_vue_1.default, { class: "hide-sm" }),
                                (0, vue_2.createVNode)(SmartHRSmallIcon_vue_1.default, { class: "show-sm" })
                            ]),
                            (0, vue_2.createElementVNode)("div", _hoisted_52, [
                                (0, vue_2.createVNode)(InfoIcon_vue_1.default, { class: "show-sm" }),
                                _hoisted_53
                            ])
                        ]),
                        (!(0, vue_2.unref)(hasProPerm))
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_54))
                            : (0, vue_2.createCommentVNode)("v-if", true),
                        (0, vue_2.createElementVNode)("label", {
                            class: (0, vue_2.normalizeClass)(["settings-input oplus-form-switch", disabledBtn.value])
                        }, [
                            (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((localSettingsData.value.enableSmartHR) = $event)),
                                type: "checkbox"
                            }, null, 512 /* NEED_PATCH */), [
                                [vue_2.vModelCheckbox, localSettingsData.value.enableSmartHR]
                            ]),
                            _hoisted_55
                        ], 2 /* CLASS */)
                    ]),
                    (0, vue_2.createCommentVNode)(" Minajin "),
                    (0, vue_2.createElementVNode)("div", _hoisted_56, [
                        (0, vue_2.createElementVNode)("div", _hoisted_57, [
                            (0, vue_2.createElementVNode)("span", _hoisted_58, [
                                (0, vue_2.createVNode)(MinajinIcon_vue_1.default, { class: "hide-sm" }),
                                (0, vue_2.createVNode)(MinajinSmallIcon_vue_1.default, { class: "show-sm" })
                            ]),
                            (0, vue_2.createElementVNode)("div", _hoisted_59, [
                                (0, vue_2.createVNode)(InfoIcon_vue_1.default, { class: "show-sm" }),
                                _hoisted_60
                            ])
                        ]),
                        (!(0, vue_2.unref)(hasProPerm))
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_61))
                            : (0, vue_2.createCommentVNode)("v-if", true),
                        (0, vue_2.createElementVNode)("label", {
                            class: (0, vue_2.normalizeClass)(["settings-input oplus-form-switch", disabledBtn.value])
                        }, [
                            (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((localSettingsData.value.enableMinajin) = $event)),
                                type: "checkbox"
                            }, null, 512 /* NEED_PATCH */), [
                                [vue_2.vModelCheckbox, localSettingsData.value.enableMinajin]
                            ]),
                            _hoisted_62
                        ], 2 /* CLASS */)
                    ]),
                    (0, vue_2.createCommentVNode)(" Xronos "),
                    (0, vue_2.createElementVNode)("div", _hoisted_63, [
                        (0, vue_2.createElementVNode)("div", _hoisted_64, [
                            (0, vue_2.createElementVNode)("span", _hoisted_65, [
                                (0, vue_2.createVNode)(XronosIcon_vue_1.default, { class: "hide-sm" }),
                                (0, vue_2.createVNode)(XronosSmallIcon_vue_1.default, { class: "show-sm" })
                            ]),
                            (0, vue_2.createElementVNode)("div", _hoisted_66, [
                                (0, vue_2.createVNode)(InfoIcon_vue_1.default, { class: "show-sm" }),
                                _hoisted_67
                            ])
                        ]),
                        (!(0, vue_2.unref)(hasProPerm))
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_68))
                            : (0, vue_2.createCommentVNode)("v-if", true),
                        (0, vue_2.createElementVNode)("label", {
                            class: (0, vue_2.normalizeClass)(["settings-input oplus-form-switch", disabledBtn.value])
                        }, [
                            (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((localSettingsData.value.enableXronos) = $event)),
                                type: "checkbox"
                            }, null, 512 /* NEED_PATCH */), [
                                [vue_2.vModelCheckbox, localSettingsData.value.enableXronos]
                            ]),
                            _hoisted_69
                        ], 2 /* CLASS */)
                    ]),
                    (0, vue_2.createCommentVNode)(" PathosLogos "),
                    ((0, vue_2.unref)(hasPathosLogosPerm))
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_70, [
                            (0, vue_2.createElementVNode)("div", _hoisted_71, [
                                (0, vue_2.createElementVNode)("span", _hoisted_72, [
                                    (0, vue_2.createVNode)(PathosLogosIcon_vue_1.default, { class: "hide-sm" }),
                                    (0, vue_2.createVNode)(PathosLogosSmallIcon_vue_1.default, { class: "show-sm" })
                                ]),
                                (0, vue_2.createElementVNode)("div", _hoisted_73, [
                                    (0, vue_2.createVNode)(InfoIcon_vue_1.default, { class: "show-sm" }),
                                    _hoisted_74
                                ])
                            ]),
                            (!(0, vue_2.unref)(hasProPerm))
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_75))
                                : (0, vue_2.createCommentVNode)("v-if", true),
                            (0, vue_2.createElementVNode)("label", {
                                class: (0, vue_2.normalizeClass)(["settings-input oplus-form-switch", disabledBtn.value])
                            }, [
                                (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => ((localSettingsData.value.enablePathosLogos) = $event)),
                                    type: "checkbox"
                                }, null, 512 /* NEED_PATCH */), [
                                    [vue_2.vModelCheckbox, localSettingsData.value.enablePathosLogos]
                                ]),
                                _hoisted_76
                            ], 2 /* CLASS */)
                        ]))
                        : (0, vue_2.createCommentVNode)("v-if", true),
                    (0, vue_2.createCommentVNode)(" Kinjiro "),
                    (0, vue_2.createElementVNode)("div", _hoisted_77, [
                        (0, vue_2.createElementVNode)("div", _hoisted_78, [
                            (0, vue_2.createElementVNode)("span", _hoisted_79, [
                                (0, vue_2.createVNode)(KinjiroSmallIcon_vue_1.default, { class: "mr-1" }),
                                (0, vue_2.createVNode)(KinjiroIcon_vue_1.default, { class: "hide-sm" })
                            ]),
                            (0, vue_2.createElementVNode)("div", _hoisted_80, [
                                (0, vue_2.createVNode)(InfoIcon_vue_1.default, { class: "show-sm" }),
                                _hoisted_81
                            ])
                        ]),
                        (!(0, vue_2.unref)(hasProPerm))
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_82))
                            : (0, vue_2.createCommentVNode)("v-if", true),
                        (0, vue_2.createElementVNode)("label", {
                            class: (0, vue_2.normalizeClass)(["settings-input oplus-form-switch", disabledBtn.value])
                        }, [
                            (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event) => ((localSettingsData.value.enableKinjiro) = $event)),
                                type: "checkbox"
                            }, null, 512 /* NEED_PATCH */), [
                                [vue_2.vModelCheckbox, localSettingsData.value.enableKinjiro]
                            ]),
                            _hoisted_83
                        ], 2 /* CLASS */)
                    ])
                ]),
                (0, vue_2.createElementVNode)("div", _hoisted_84, [
                    (0, vue_2.createElementVNode)("button", {
                        class: (0, vue_2.normalizeClass)(["oplus-modal-btn oplus-alt-confirm-btn", loadingClass.value]),
                        onClick: handleOemSubmit
                    }, "確定", 2 /* CLASS */)
                ])
            ]));
        };
    }
});
